import { removeCommaSeparator } from '@ajaibid/utils';

/**
 *
 * @param {Number} price
 * @param {Number} lot
 * @returns price * lot * 100
 */
const stockCalculateTotal = (price = 0, lot = 0) => {
  if (typeof price === 'string' || typeof lot === 'string') {
    const tempPrice = parseInt(removeCommaSeparator(String(price)), 10);
    const tempLot = parseInt(removeCommaSeparator(String(lot)), 10);
    return tempPrice * tempLot * 100;
  }

  return price * lot * 100;
};

export default stockCalculateTotal;
